import dayjs from "dayjs";

function getRealPath() {
  return document.location.origin;
}
// UUID js 实现
function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
function contains(source, target) {
  if (source.match(target) != null) {
    return true;
  }
  return false;
}

function indexOfContains(source, target) {
  if (source.indexOf(target) != -1) {
    return true;
  }
  return false;
}
// 判断任何对象是否为空
function isEmpty(data) {
  let type = Object.prototype.toString
    .call(data)
    .split(" ")[1]
    .replace("]", "");
  if (["Array", "String"].includes(type)) {
    return data && data.length > 0 ? false : true;
  } else if (["Undefined", "Null"].includes(type)) {
    return true;
  } else if (type == "Object") {
    return Object.keys(data).length > 0 ? false : true;
  } else {
    return false;
  }
}
function dataToString(
  date,
  type = "normal",
  format = "YYYY-MM-DD HH:mm:ss",
  offset = 0
) {
  if (isEmpty(date)) {
    return "";
  }
  date = Number(date);
  let nowTimeZone = new Date().getTimezoneOffset() * 60000;
  offset = offset ? Number(offset) : -nowTimeZone;
  if (date) {
    if (nowTimeZone > 0) {
      date = date - nowTimeZone;
    } else {
      date = date + nowTimeZone;
    }
    return dayjs(date + offset).format(format);
  } else {
    if (type == "normal") {
      return "";
    }
    return dayjs(0).format(format);
  }
}
function dataToDay(date, format = "YYYY-MM-DD", offset = 0) {
  let nowTimeZone = new Date().getTimezoneOffset() * 60000;
  offset = offset ? Number(offset) : -nowTimeZone;
  if (date) {
    date = dayjs(date).valueOf();
    date = date + nowTimeZone;
    return dayjs(date + offset).format(format);
  } else {
    return "";
  }
}

function testBase64(data) {
  let regexp = new RegExp("^data:image/.*;base64,.*$");
  return regexp.test(data);
}

function removeOtherLocalStoreage() {
  // 遍历清除 非 i18n 配置
  let i18nkeys = ["localeLanguage", "as-languageList", "as-languageData"];
  let length = localStorage.length;
  let keys=[]
  for (let i = 0; i < length; i++) {
    let key = localStorage.key(i);
    if (!i18nkeys.includes(key)) {
      keys.push(key)
    }
  }
  keys.forEach(key=>{
    localStorage.removeItem(key);
  })
  localStorage.removeItem("as-pwdFlag");
  localStorage.removeItem("as-loginFlag");
}
export {
  getRealPath,
  guid,
  isEmpty,
  contains,
  dataToString,
  indexOfContains,
  dataToDay,
  testBase64,
  removeOtherLocalStoreage,
};
